// BENGALURU
import banner1 from "../assets/landingpage/award-ceremonies/BENGALURU/BLR-1.JPG"
import banner2 from "../assets/landingpage/award-ceremonies/BENGALURU/BLR-2.JPG"
import banner3 from "../assets/landingpage/award-ceremonies/BENGALURU/BLR-7.JPG"
import banner4 from "../assets/landingpage/award-ceremonies/BENGALURU/BLR-10.JPG"
import banner5 from "../assets/landingpage/award-ceremonies/BENGALURU/BLR-24.JPG"
import banner6 from "../assets/landingpage/award-ceremonies/BENGALURU/BLR-40.JPG"

//HYDERABAD
import banner7 from "../assets/landingpage/award-ceremonies/HYDERABAD/DSC00366.JPG"
import banner8 from "../assets/landingpage/award-ceremonies/HYDERABAD/DSC00372.JPG"
import banner9 from "../assets/landingpage/award-ceremonies/HYDERABAD/DSC00380.JPG"
import banner10 from "../assets/landingpage/award-ceremonies/HYDERABAD/DSC00393.JPG"
import banner11 from "../assets/landingpage/award-ceremonies/HYDERABAD/DSC00409.JPG"
import banner12 from "../assets/landingpage/award-ceremonies/HYDERABAD/DSC00534.JPG"

//CHENNAI
import banner13 from "../assets/landingpage/award-ceremonies/CHENNAI/DSC03382.JPG"
import banner14 from "../assets/landingpage/award-ceremonies/CHENNAI/DSC03438.JPG"
import banner15 from "../assets/landingpage/award-ceremonies/CHENNAI/DSC03456.JPG"
import banner16 from "../assets/landingpage/award-ceremonies/CHENNAI/DSC03498.JPG"
import banner17 from "../assets/landingpage/award-ceremonies/CHENNAI/DSC03526.JPG"
import banner18 from "../assets/landingpage/award-ceremonies/CHENNAI/DSC03548.JPG"

//VIJAYAWADA
import banner19 from "../assets/landingpage/award-ceremonies/VIJAYAWADA/DSC09600.JPG"
import banner20 from "../assets/landingpage/award-ceremonies/VIJAYAWADA/DSC09634.JPG"
import banner21 from "../assets/landingpage/award-ceremonies/VIJAYAWADA/DSC09723.JPG"
import banner22 from "../assets/landingpage/award-ceremonies/VIJAYAWADA/DSC09794.JPG"
import banner23 from "../assets/landingpage/award-ceremonies/VIJAYAWADA/DSC09803.JPG"
import banner24 from "../assets/landingpage/award-ceremonies/VIJAYAWADA/DSC09829.JPG"

// Videos

export const awardImageGallery = [
  {
    caption: "Bangalore",
    banners: [
      {
        id: 1,
        image: banner1,
      },
      {
        id: 2,
        image: banner2,
      },
      {
        id: 3,
        image: banner3,
      },
      {
        id: 4,
        image: banner4,
      },
      {
        id: 5,
        image: banner5,
      },
      {
        id: 6,
        image: banner6,
      },
    ],
  },
  {
    caption: "Hyderabad",
    banners: [
      {
        id: 7,
        image: banner7,
      },
      {
        id: 8,
        image: banner8,
      },
      {
        id: 9,
        image: banner9,
      },
      {
        id: 10,
        image: banner10,
      },
      {
        id: 11,
        image: banner11,
      },
      {
        id: 12,
        image: banner12,
      },
    ],
  },
  {
    caption: "Chennai",
    banners: [
      {
        id: 13,
        image: banner13,
      },
      {
        id: 14,
        image: banner14,
      },
      {
        id: 15,
        image: banner15,
      },
      {
        id: 16,
        image: banner16,
      },
      {
        id: 17,
        image: banner17,
      },
      {
        id: 18,
        image: banner18,
      },
    ],
  },
  {
    caption: "Vijayawada",
    banners: [
      {
        id: 19,
        image: banner19,
      },
      {
        id: 20,
        image: banner20,
      },
      {
        id: 21,
        image: banner21,
      },
      {
        id: 22,
        image: banner22,
      },
      {
        id: 23,
        image: banner23,
      },
      {
        id: 24,
        image: banner24,
      },
    ],
  },
];

export const videoGallery = [
  {
    id: 4,
    caption: "CNAPS Toppers Feedback",
    youtubeLink: "https://www.youtube.com/watch?v=48zRD-fgib8",
  },
  {
    id: 2,
    caption: "Hyderabad",
    youtubeLink: "https://www.youtube.com/watch?v=kI1hd5S5KtA",
  },
  {
    id: 1,
    caption: "Bengaluru",
    youtubeLink: "https://www.youtube.com/watch?v=lbwquAOFir0",
  },
  {
    id: 3,
    caption: "Chennai",
    youtubeLink: "https://www.youtube.com/watch?v=L8XiGiqClSA",
  },{
    id: 3,
    caption: "Vijayawada",
    youtubeLink : 'https://www.youtube.com/watch?v=03sHSK9EE7Q'
  },
];
